import { CustomColumnTypes } from "@/enum/list.enum";

import { ColumnConfig } from "../../../../List/schema/columnConfig";

/** Row model of the spintax section: one RANDOM_VALUE column of the list. */
export interface SpintaxRow {
	key: string;
	/** Column name, e.g. "10h | 11h | 14h". */
	name: string;
	columnId: number;
	column: ColumnConfig;
	/** Number of values the column picks from. */
	variationCount: number;
	/** Whether the column's placeholder occurs in the selected node's messages. */
	isInserted: boolean;
}

export const normalizeSpintaxSearch = (value?: string | null): string =>
	(value ?? "").trim().toLowerCase();

interface BuildSpintaxRowsArgs {
	/** Columns of the current list, in list order. */
	listColumns?: ColumnConfig[];
	/** Column ids referenced by the current message bodies. */
	insertedColumnIds: number[];
}

/**
 * Maps the list's RANDOM_VALUE columns to section rows, preserving list order
 * and marking rows whose placeholder occurs in the selected node's messages.
 */
export const buildSpintaxRows = ({
	listColumns,
	insertedColumnIds,
}: BuildSpintaxRowsArgs): SpintaxRow[] =>
	(listColumns ?? [])
		.filter((column) => column.type === CustomColumnTypes.RANDOM_VALUE && column.id != null)
		.map((column) => ({
			key: `col-${column.id}`,
			name: column.name ?? "",
			columnId: column.id as number,
			column,
			variationCount: Array.isArray(column.config) ? column.config.length : 0,
			isInserted: insertedColumnIds.includes(column.id as number),
		}));
